import Modal, { ModalFooter, ModalHeader, Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeleteLotteryModalProps {
  visible: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteLotteryModal: React.FC<DeleteLotteryModalProps> = ({
  visible,
  onClose,
  onDelete,
}) => {
  const { t } = useTranslation();
  const deleteLotteryTitleId = t('general-delete-lottery');

  return (
    <Modal visible={visible} escapable={false} handleCloseBtn={onClose}>
      <Prompt
        aria-labelledby={deleteLotteryTitleId}
        title={t('edit-lottery-delete-modal-header')}
        titleId={deleteLotteryTitleId}
        header={<ModalHeader ariaCloseTxt={`${t('general-close-prompt')}`} />}
        footer={
          <ModalFooter>
            <Button text={`${t('general-cancel')}`} type="secondary" onClick={onClose} />
            <Button text={`${t('general-delete-lottery')}`} type="primary" onClick={onDelete} />
          </ModalFooter>
        }
      >
        <p>{t('edit-lottery-info-modal')}</p>
      </Prompt>
    </Modal>
  );
};
